module.exports = __webpack_public_path__ + "assets/img/border.afce8f72.png";